export { onRouterTransitionStart } from '@datadog/browser-rum-nextjs';
